export class ChatThreadMessage {
    constructor(model) {
        this.id = model.id;
        this.threadId = model.threadId;
        this.payload = model.payload;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : new Date();
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : new Date();
        this.sender = model.sender;
    }
    toRemote() {
        return {
            id: this.id,
            threadId: this.threadId,
            payload: this.payload,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            sender: this.sender,
        };
    }
}
